import React from 'react';
import Head from 'next/head';
import { useRouter } from 'next/router';
import { useSelector } from 'react-redux';
import isIterable from '~/src/lib/isIterable';

function App(props) {
    const router = useRouter();

    const business = useSelector((state) => state.business);
    const lang = useSelector((state) => state.lang);

    /*
    React.useEffect(() => {
        console.log(6677);
        console.log(router);
        console.log(window.location.origin);
        console.log(lang);

        const url = `${window.location.origin}/${lang}${router.asPath}`;
        console.log(url);
        

    }, [business, lang]);
    */

    if (business && isIterable(business.languages2)) {
        const languages = business.languages2.filter((o) => o.display === 1);
        if (languages && languages.length > 1) {
            //console.log(languages);

            const datas = [];

            languages.map((l) => {
                const url = `${window.location.origin}/${l.iso2}${router.asPath}`;

                datas.push({
                    url: url,
                    lang: l.iso2,
                });
                return false;
            });

            return (
                <Head>
                    {datas.map((data, index) => {
                        return (
                            <link
                                key={index}
                                rel="alternate"
                                hreflang={data.lang}
                                href={data.url}
                            />
                        );
                    })}
                </Head>
            );
        }
    }

    return false;
}

export default App;
